import { Flex } from "@chakra-ui/layout";
import {
  UnidadePessoaHistorico,
  TipoUnidadePessoaEnum,
} from "core/features/unidades/typings/unidade";
import { useMemo } from "react";
import { Image } from "@chakra-ui/react";
import { MdPerson } from "react-icons/md";
import { Tag } from "@chakra-ui/tag";
import { BsKey } from "react-icons/bs";
import moment from "moment";

function useHistoricoPessoasCardColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome",
        width: 300,
        render: (original: UnidadePessoaHistorico) => (
          <Flex align="center" gap={4}>
            <Flex>
              {original.imagemUrl ? (
                <Image
                  src={original.imagemUrl}
                  rounded="full"
                  w="35px"
                  h="35px"
                  objectFit="cover"
                  maxW="unset"
                />
              ) : (
                <Flex
                  w="35px"
                  h="35px"
                  justifyContent="center"
                  alignItems="center"
                  rounded="full"
                  bg="gray.100"
                >
                  <MdPerson fontSize="18px" />
                </Flex>
              )}
            </Flex>
            <Flex>{original.nome}</Flex>
          </Flex>
        ),
      },

      {
        title: "",
        width: 150,
        render: (original: UnidadePessoaHistorico) => {
          return (
            <Flex>
              {original.tipoUnidadePessoa.id ===
              TipoUnidadePessoaEnum.Proprietario ? (
                <Tag colorScheme="orange" size="sm">
                  <BsKey style={{ marginRight: 8 }} />
                  Proprietário
                </Tag>
              ) : original.tipoUnidadePessoa ? (
                <Tag variant="outline" colorScheme="orange" size="sm">
                  {original.tipoUnidadePessoa.nome}
                </Tag>
              ) : null}
            </Flex>
          );
        },
      },
      {
        title: "",
        render: (original: UnidadePessoaHistorico) => {
          return (
            <Flex>
              <Tag
                variant="outline"
                rounded={15}
                fontWeight="normal"
                colorScheme="gray"
              >
                Data de entrada{" "}
                {moment(original.createdAt).format("DD/MM/YYYY")}
                {original.deletedAt
                  ? `> Data de saída
                ${moment(original.deletedAt).format("DD/MM/YYYY")} `
                  : null}
              </Tag>
            </Flex>
          );
        },
      },
    ];
  }, []);
}

export default useHistoricoPessoasCardColumns;
